import StepExecutor from "../StepExecutor";
import EQError from "../../utils/EQError";
import * as Error from "../../utils/EQError";
import EQPauseStepProgress from "../../../public-apis/onclick/EQPauseStepProgress";
import EQPauseStepDone from "../../../public-apis/onclick/EQPauseStepDone";

/**
 * Represent a pause between two steps
 */
export default class PauseStepExecutor extends StepExecutor {

    /**
     * @param {ConfigStepPause} configuration a {@link ConfigStepPause}
     */
    constructor(configuration) {
        super(configuration);
        this.waitingTime = configuration.pause; // Use the config value
    }

    startInternal(resolve, reject, progress) {
        this.runSleep(resolve, reject, progress, this.waitingTime, this.waitingTime);
    }

    /**
     * Run a sleep iteration
     * @param {function} resolve resolver callback for a promise
     * @param {function} reject rejected callback for a promise
     * @param {function} progress alert each seconds with the current second
     * @param {number} remainingTime in seconds
     * @param {number} maxTime the maximum seconds to sleep
     */
    runSleep(resolve, reject, progress, remainingTime, maxTime) {
        if (this.isCancelled()) {
            reject(new EQError('Step is cancelled', Error.SCRIPT_STEP_CANCELLED));
            return;
        }
        if (remainingTime == 0) {
            // Pause is over
            resolve(new EQPauseStepDone(maxTime));
        } else {
            // Alert progress with remainingTime
            progress(new EQPauseStepProgress(maxTime, remainingTime));
            this.sleep1second(remainingTime).then((result) => {
                this.runSleep(resolve, reject, progress, result, maxTime);
            });
        }
    }

    /**
     * Sleep during 1 seconds and resolve the promise with the arg - 1
     * @param {number} arg the argument to decrease
     * @returns {Promise} with the arg decrease by one when resolved
     */
    sleep1second(arg) {
        return new Promise((resolve) => setTimeout(() => {
            resolve(arg - 1)
        }, 1000));
    }

    stopInternal() {
        // Manage from the runSleep method with the isStopped method
        return true;
    }

}


// WEBPACK FOOTER //
// ./js/core/script/executors/PauseStepExecutor.js